// CONSTANTS are all caps.
const NS = 'ReactMakeAppointmentContainer';
const CLS = 'reactMakeAppointmentContainer';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import ReactMakeAppointmentContainerStep2 from './ReactMakeAppointmentContainerStep2.jsx';
import ReactGoogleAutocomplete from './ReactGoogleAutocomplete.jsx';
import React from 'react';
import ReactDOM from 'react-dom';

window.reactMakeAppointmentContainerData = {};

export class ReactMakeAppointmentContainer {
	constructor(el) {
		this.el = el;
		this.$el = $(this.el);
		this.api = $(this.el).data('api');

		this.filters = {};
		this.init();

		this.checkboxGroupValid = false;
		this.googleAutocompleteValid = false;
	}

	init() {
		this.initStep1();
		this.initStep3();
	}

	initStep1() {
		// navigate step 1 ---> step 2
		let form = document.getElementById(`${CLS}Step1Form`);
		form.addEventListener('submit', (event) => {
			// input are valid
			if(!form.checkValidity()) {
				event.preventDefault();
				event.stopPropagation();
			}
			else {
				event.preventDefault();
				event.stopPropagation();
				// if custom element validation == true
				if(this.checkboxGroupValid === true) {
					console.log('submit');
					this.$el.find('#reactMakeAppointmentContainerStep1').css('display', 'none');
					this.$el.find('#reactMakeAppointmentContainer-nav').attr('data-active-index', '2');
					this.initStep2();
				}
			}
			form.classList.add('was-validated');
			this.updateErrorMsg('reactMakeAppointmentContainerStep1');
		}, false);

		// init google autocomplete in Step 1
		ReactDOM.render(
			React.createElement(
				ReactGoogleAutocomplete,
				{
					value: null,
					onChange: null,
					inReact: false
				}
			),
			document.getElementById(`reactMakeAppointmentContainerStep1-google-autocomplete`)
		);
		this.initFilters();
	}

	/**
	 * handling the all input fields in step 1 form
	 * and collecting the data and pass
	 * to step 2 React component
	 */
	initFilters() {
		this.$el.find('input').on('change', e => {
			let type = $(e.currentTarget).attr('type');
			let name = $(e.currentTarget).attr('name');
			let $formGroup = this.$el.find(`.form-group[data-key=${name}]`);
			let filter = {};

			if(type === 'radio') {
				let $radio = $formGroup.find('input:checked');
				filter = {
					type: 'radio',
					key: name,
					value: $($radio[0]).val()
				};
			} else if(type === 'checkbox') {
				let $checkboxes = $formGroup.find('input:checked');
				let arr = [];
				$checkboxes.each((i, e) => {
					arr.push($(e).val());
				})
				filter = {
					type: 'checkbox',
					key: name,
					value: arr
				};

				arr.length > 0
					? this.checkboxGroupValid = true
					: this.checkboxGroupValid = false;
			}
			this.filters[filter.key] = filter.value;
			window.reactMakeAppointmentContainerData.filters = this.filters;
			this.updateErrorMsg('reactMakeAppointmentContainerStep1');
		});
	}

	/**
	 * hide/show invalid-feedback for
	 * each form check element
	 * @param {string} step namespace for each step
	 */
	updateErrorMsg(step) {
		// update basic form element validation msg
		$(`#${step} .invalid-feedback`).css('display', 'none');
		let $arr = $(`#${step} .was-validated .form-check-input:invalid`)
		$arr.each((i, e) => {
			$(e).parent().siblings('.invalid-feedback').css('display', 'block');
		});
		// 1. multiple checkboxes
		if(step === 'reactMakeAppointmentContainerStep1' && this.checkboxGroupValid === false) {
			$(`#${step} input[type="checkbox"]`).parent().siblings('.invalid-feedback').css('display', 'block');
		}
		// 2. google autocomplete
		if(step === 'reactMakeAppointmentContainerStep1' && this.googleAutocompleteValid === false) {
			$(`.${CLS}Step1-google-autocomplete.invalid-feedback`).css('display', 'block');
		}
	}

	initStep3() {
		// navigate step 2 <--- step 3
		$(this.el).find('#reactMakeAppointmentContainerStep3-previous-btn').on('click', () => {
			this.$el.find('#reactMakeAppointmentContainerStep2').css('display', 'block');
			this.$el.find('#reactMakeAppointmentContainerStep3').css('display', 'none');
			this.$el.find('#reactMakeAppointmentContainer-nav').attr('data-active-index', '2');
		});
	}

	initStep2() {
		// form data and pass to step 2
		window.reactMakeAppointmentContainerData.api = this.api;
		/**
		 * window.reactMakeAppointmentContainerData Data Structure
		 * 1.  @param {string} api
		 * 2.  @param {object} googleAutocompleteData
		 * 3.  @param {object} filters
		 */
		// Add Some logic here
		ReactDOM.render(
			React.createElement(
				ReactMakeAppointmentContainerStep2,
				window.reactMakeAppointmentContainerData
			),
			document.getElementById(`reactMakeAppointmentContainerStep2`)
		);
	}

	// Add more functions like on above here
}
